<template>
    <div
        :class="[classesProp, { 'c-dropdown-btn__hovered': isHovering }]"
        class="c-dropdown-btn"
    >
        <button
            v-if="!forceOpen"
            :class="btnClassesProp"
            @mouseenter="isHovering = true"
            @mouseleave="isHovering = false"
        >
            <slot name="title" />
            <IconArrow
                v-if="!forceOpen"
                class="c-dropdown-btn__arrow icon icon-dropdown-arrow"
                :class="{
                    'c-dropdown-btn__arrow--down':
                        (displayAsDropUp && isHovering) ||
                        (!displayAsDropUp && !isHovering),
                    'c-dropdown-btn__arrow--up':
                        (displayAsDropUp && !isHovering) ||
                        (!displayAsDropUp && isHovering),
                }"
            />
        </button>
        <div
            class="c-dropdown-btn--dropdown"
            :class="{
                'force-open': forceOpen,
                'drop-up': displayAsDropUp,
                'c-header__dropdown': isHeaderDropdown,
            }"
            @mouseenter="isHovering = true"
            @mouseleave="isHovering = false"
            @click="isHovering = false"
        >
            <slot name="items" />
        </div>
    </div>
</template>
<script>
import IconArrow from '@/assets/svg/ui/dropdown-arrow.svg?component';

export default {
    components: { IconArrow },
    props: {
        classesProp: {
            type: String,
            required: false,
            default: '',
        },
        btnClassesProp: {
            type: String,
            required: false,
            default: '',
        },
        displayAsDropUp: {
            type: Boolean,
            required: false,
            default: false,
        },
        forceOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        isHeaderDropdown: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isHovering: false,
        };
    },
};
</script>

<style lang="scss">
.c-dropdown-btn {
    position: relative;
    z-index: 1;

    > button:first-child {
        align-self: stretch;
    }

    .btn {
        display: flex;
        justify-content: center;
    }

    .icon {
        margin-left: 4px;
    }

    .icon-dropdown-arrow {
        width: 16px;
        height: 16px;
        display: inline-block;
        color: white;
        transition: 0.2s ease-in-out;
    }

    &__arrow--up {
        transform: scaleY(-1);
        margin-top: 8px;
    }

    &--dropdown {
        position: absolute;
        display: none;
        background-color: $secondary-theme-color;
        font-size: 1.2rem;
        width: 100%;

        ul {
            list-style: none;
            margin: 0;
            padding: 0;
            min-width: fit-content;

            li {
                margin: 0;
                padding: 0;
                display: flex;
                align-items: center;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);

                a,
                .icon {
                    display: inline-block;
                }

                .icon {
                    margin-right: 10px;
                }

                a {
                    color: #fff;
                    padding: 1rem;
                    width: 100%;

                    &:hover {
                        text-decoration: none;
                    }
                }

                &:hover {
                    background-color: $quaternary-theme-color;
                }
            }

            li:last-child {
                border-bottom: none;
            }
        }
    }

    .force-open {
        display: block;
    }

    &__hovered {
        &:hover .c-dropdown-btn--dropdown {
            display: block;
            border: none;

            .btn h4 {
                color: #fff;
            }
        }
    }

    .drop-up {
        bottom: 60px;
    }
}
</style>
